export default __webpack_public_path__ + "cbd660b553bbf7a99d1973f055b1fa65.otf";